var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"dark":""}},[_c('site-header',{attrs:{"title":_vm.title}}),_c('v-main',[_c('router-view',{key:_vm.$route.fullPath}),_c('footer-top',{attrs:{"footerForm":_vm.footerForm}})],1),_c('site-footer',{attrs:{"title":_vm.title}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }